export default "__VITE_ASSET__BAQGiUNZ__"